export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";